/* global module*/

import React, { Component } from 'react';
import cx from 'classnames';

class AlertsComponent extends Component {

  constructor(props, context) {
    super(props, context);
    const alerts = this;
    alerts.state = {};
  }

  get not_empty() {
    return this.props.list.length !== 0;
  }

  alertAction(action) {
    if (action === 'confirmAccount') {
      this.props.confirmAccount();
    }
  }

  translateAlert(alert) {
    const alerts = this;
    if (alert.needs_i18n) {
      return alerts.t(alert.message);
    }
    return alert.message;
  }

  render() {
    return (
      <div className="alerts">
        {this.not_empty && this.props.list.map((alertData, i) => (
          <div
            key={`alert-${i}`}
            className={cx('alert', { 'alert-success': alertData.type === 'success', 'alert-danger': alertData.type === 'danger' })}
          >
            {this.translateAlert(alertData)}
            {alertData.actions.map((action, j) => (
              <a href="#" onClick={() => this.alertAction(action.action)} className="alert-link" key={`alert-${i}-action-${j}`}>
                {action.text}
              </a>
            ))}
          </div>
        ))}
      </div>
    );
  }
}


AlertsComponent.propTypes = {
  list: React.PropTypes.array.isRequired,
  confirmAccount: React.PropTypes.func,
};

AlertsComponent.NAME = 'Alerts';

export default AlertsComponent;
